import { useEffect } from 'react';
import { Text } from 'ink';

import { getAuthConfig } from '../utilities/configStore';
import ErrorBoundary from '../components/ErrorBoundary';
import LoginHOC from '../components/LoginHOC';
import { useAnalyticsCommand } from '../utilities/useAnalytics';
import useExit from '../utilities/useExit';

function WhoAmI() {
  const exit = useExit();
  const auth = getAuthConfig();
  const { hasAttemptedTracking } = useAnalyticsCommand('whoami', {}, {});

  // exits the program once tracking of the "whoami" command has been attempted
  useEffect(() => {
    if (hasAttemptedTracking) {
      exit();
    }
  }, [exit, hasAttemptedTracking]);

  if (!auth || !auth.email) {
    return <Text>You&apos;re not signed in</Text>;
  }
  return <Text>{auth.email}</Text>;
}

export default function WhoAmIWrapper() {
  return (
    <ErrorBoundary>
      <LoginHOC isInteractive={false}>
        <WhoAmI />
      </LoginHOC>
    </ErrorBoundary>
  );
}
